<template>
  <v-form ref="form" @submit.prevent>
    <v-container class="px-2 lgpd-wrap">
      <v-row no-gutters justify="center">
        <v-col cols="12" md="8" class="lgpd-col">
          <h1 class="lgpd-title primary--text">
            Termo de consentimento para tratamento de dados pessoais (LGPD)
          </h1>

          <p class="lgpd-p">
            Ao aceitar esse documento, o TITULAR registra a manifestação livre, informada, expressa e consciente, no
            sentido de autorizar a Empresa Limer, denominada neste documento como CONTROLADORA, a realizar o tratamento
            de Dados Pessoais para finalidade específica, em observância à Lei nº. 13.709/18 – Lei Geral de Proteção de
            Dados Pessoais e demais normativas aplicáveis sobre proteção de Dados Pessoais.
          </p>

          <p class="lgpd-p">
            Ao manifestar sua aceitação ao presente termo, o TITULAR consente e concorda que a empresa Limer Gestão de
            Saúde Corporativa, CNPJ nº 24.809.516/0001-40, com sede na Avenida Antonio Artioli, Swiss Park Office,
            Campinas, SP, e-mail suporte@limer.med.br, doravante denominada CONTROLADORA, tome decisões referentes ao
            tratamento de seus dados pessoais, bem como realize o tratamento de seus dados pessoais, envolvendo as
            seguintes operações: coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão,
            distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação,
            modificação, comunicação, transferência, difusão ou extração, única e exclusivamente para o desenvolvimento
            dos serviços de medicina do trabalho.
          </p>

          <section v-for="(s, si) in sections" :key="si" class="lgpd-section">
            <h2 class="lgpd-h2">{{ s.title }}</h2>

            <p v-for="(p, pi) in s.paras" :key="'p' + pi" class="lgpd-p">{{ p }}</p>

            <h3 v-if="s.subtitle" class="lgpd-h3">{{ s.subtitle }}</h3>

            <p v-for="(p, pi) in s.paras2" :key="'p2' + pi" class="lgpd-p">{{ p }}</p>

            <div v-for="(it, ii) in s.numbered" :key="'n' + ii" class="lgpd-num">
              <span class="lgpd-num-n">{{ it.n }}</span>
              <div>
                <p class="lgpd-p lgpd-p--tight">{{ it.t }}</p>
                <ul v-if="it.bullets && it.bullets.length" class="lgpd-list lgpd-list--nested">
                  <li v-for="(b, bi) in it.bullets" :key="'nb' + bi" class="lgpd-li">
                    <span class="lgpd-dot"></span><span>{{ b }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <ul v-if="s.bullets && s.bullets.length" class="lgpd-list">
              <li v-for="(b, bi) in s.bullets" :key="'b' + bi" class="lgpd-li">
                <span class="lgpd-dot"></span><span>{{ b }}</span>
              </li>
            </ul>

            <p v-if="s.closing" class="lgpd-p">{{ s.closing }}</p>
          </section>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      sections: [
        {
          title: 'Dados Pessoais',
          paras: [
            'O TITULAR autoriza a CONTROLADORA a realizar o tratamento, ou seja, a utilizar os seguintes dados pessoais, para os fins que serão relacionados nas cláusulas seguintes:'
          ],
          bullets: [
            'Dados de usuário para controle de acesso ( login e senha )',
            'Nome completo',
            'Email',
            'RG',
            'CPF',
            'Data de nascimento',
            'Sexo',
            'Endereço completo;',
            'Grau de escolaridade',
            'Números para contato ( Telefone, wathsapp )',
            'Portador de deficiência',
            'Data de admissão',
            'Data de demissão',
            'NIT',
            'CTPS',
            'Matrícula',
            'CBO',
            'Setor / Função / Cargo / Profissão',
            'Dados referente a saúde (anamnese, exame clínico, exames laboratoriais, exames radiológicos, exames audiométricos, exames psicossociais)',
            'Exames e atestados médicos, especialmente admissionais, periódicos, incluídos de retorno por afastamento superior a 30 dias em caso de doença, acidente ou parto, de mudança de função, demissionais e ainda aqueles que atestem doença ou acidente;',
            'CID',
            'Doenças pré-existentes'
          ]
        },
        {
          title: 'Finalidades do Tratamento dos Dados',
          paras: ['Os dados pessoais poderão ser utilizados pela CONTROLADORA para os seguintes fins.'],
          bullets: [
            'Cumprir as obrigações contratuais, legais e regulatórias da CONTROLADORA, em razão de suas atividades;',
            'Possibilitar que a CONTROLADORA realize comunicação oficial através da Plataforma ou por seus prestadores de serviço, por meio de quaisquer canais de comunicação (telefone, e-mail, SMS, WhatsApp, etc.).',
            'Possibilitar que a CONTROLADORA gere documentos, relatórios e indicadores relacionados a medicina e segurança do trabalho.',
            'Possibilitar que a CONTROLADORA realize o tratamento de exames médicos conforme acordo comercial.',
            'Possibilitar que a CONTROLADORA utilize tais dados: emissão de Notas Fiscais e documentos financeiros correlatos.',
            'Possibilitar que a CONTROLADORA utilize dados pessoais dos seus usuários / colaboradores coletados, incluindo aqueles direta ou indiretamente relacionados com a sua saúde, com objetivo de serem tratados para efeitos de prestação de cuidados integrados de saúde ocupacional, incluindo gestão dos sistemas e demais serviços, auditoria e melhoria contínua dos mesmos, podendo ser relacionados e cruzados com os dados da CONTROLADORA ou de suas clínicas parceiras que possuam o mesmo objetivo.'
          ]
        },
        {
          title: 'Compartilhamento de Dados',
          paras: [
            'A CONTROLADORA fica autorizada a compartilhar os dados pessoais e dados pessoais sensíveis do TITULAR com outros agentes de tratamento de dados, caso seja necessário para as finalidades listadas neste termo, observados os princípios e as garantias estabelecidas pela Lei nº 13.709.'
          ],
          numbered: [
            {
              n: '1.',
              t: 'Compartilhamento de dados internamente: O compartilhamento de dados internamente se dará de forma a garantir a intenção de obter a prestação de serviços ofertados pela CONTROLADORA e a necessidade entre os setores desta organização, tal como: Serviço de Apoio ao Cliente (SAC), Financeiro, Segurança do Trabalho, Atendimento, Marketing, Sistema de Apoio ao Franqueado (SAF), Tecnologia da informação (T.I).'
            },
            {
              n: '2.',
              t: 'Compartilhamento de dados externo: O compartilhamento de dados para entidades externas se dará exclusivamente de forma a garantir a intenção de obter a prestação de serviços ofertados pela CONTROLADORA, o compartilhamento poderá ocorrer para as seguintes entidades:',
              bullets: [
                'Clínicas e médicos parceiros SESMT',
                'Laboratórios de análises e exames clínicos,',
                'Sistemas da informação para laudos e exames,',
                'Sistemas da informação para recursos humanos,',
                'Sistemas governamentais,',
                'Sistemas para emissão de notas fiscais, exclusivamente para o desenvolvimento dos serviços de medicina e segurança do trabalho.'
              ]
            }
          ]
        },
        {
          title: 'Segurança dos Dados',
          paras: [
            'A Controladora se responsabiliza por manter medidas de segurança, técnicas e administrativas suficientes a proteger os dados pessoais do TITULAR e à Autoridade Nacional de Proteção de Dados (ANPD), comunicando ao TITULAR, caso ocorra algum incidente de segurança que possa acarretar risco ou dano relevante, conforme artigo 48 da Lei n° 13.709/2020.'
          ],
          subtitle: 'Término do Tratamento dos Dados e Direito de Revogação do Consentimento',
          paras2: [
            'O TITULAR poderá revogar seu consentimento, a qualquer tempo, por e-mail ou por carta escrita, conforme o artigo 8°, § 5°, da Lei n° 13.709/2020.',
            'Os dados pessoais anonimizados, sem possibilidade de associação ao indivíduo, poderão ser mantidos por período indefinido.',
            'O TITULAR poderá solicitar via e-mail, canais de comunicação da CONTROLADORA, a qualquer momento, que sejam eliminados os dados pessoais não anonimizados do TITULAR, desde que não viole outras leis que exigem a guarda dos dados por um tempo pré-estabelecido.',
            'O TITULAR fica ciente de que poderá ser inviável a CONTROLADORA continuar o fornecimento de produtos ou serviços ao TITULAR a partir da eliminação dos dados pessoais.',
            'O TITULAR fica ciente que CONTROLADORA poderá manter e tratar os dados pessoais do TITULAR durante todo o período em que os mesmos forem pertinentes ao alcance das finalidades listadas neste termo:'
          ],
          bullets: [
            'Para cumprimento de obrigações decorrentes da legislação trabalhista e previdenciária.',
            'Para procedimentos de admissão e execução do contrato de trabalho, inclusive após seu término;',
            'Para cumprimento, pela CONTROLADORA, de obrigações impostas por órgãos de fiscalização;',
            'Para o exercício regular de direitos em processo judicial, administrativo ou arbitral;',
            'Para a proteção da vida ou da incolumidade física do TITULAR ou de terceiros;',
            'Para a tutela da saúde, exclusivamente, em procedimento realizado por profissionais de saúde, serviços de saúde ou autoridade sanitária;'
          ]
        },
        {
          title: 'Tempo de Permanência dos Dados Recolhidos',
          paras: [
            'O TITULAR fica ciente de que a CONTROLADORA deverá permanecer com os seus dados pelo período mínimo de guarda de documentos trabalhistas, previdenciários, bem como os relacionados à segurança e saúde no trabalho, mesmo após o encerramento do vínculo empregatício.'
          ]
        },
        {
          title: 'Direitos do TITULAR',
          paras: [
            'O TITULAR tem direito a obter da CONTROLADORA, em relação aos dados por ele tratados, a qualquer momento e mediante requisição:'
          ],
          numbered: [
            { n: '1.', t: 'confirmação da existência de tratamento;' },
            { n: '2.', t: 'acesso aos dados;' },
            { n: '3.', t: 'correção de dados incompletos, inexatos ou desatualizados;' },
            { n: '4.', t: 'anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com o disposto na Lei nº 13.709;' },
            { n: '5.', t: 'portabilidade dos dados a outro fornecedor de serviço ou produto, mediante requisição expressa e observados os segredos comercial e industrial, de acordo com a regulamentação do órgão controlador;' },
            { n: '6.', t: 'eliminação dos dados pessoais tratados com o consentimento do TITULAR, exceto nas hipóteses previstas no art. 16 da Lei nº 13.709;' },
            { n: '7.', t: 'informação das entidades públicas e privadas com as quais o controlador realizou uso compartilhado de dados;' },
            { n: '8.', t: 'informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa;' },
            { n: '9.', t: 'revogação do consentimento, nos termos do § 5º do art. 8º da Lei nº 13.709.' }
          ],
          closing:
            'A CONTROLADORA se compromete a manter total sigilo e ainda a utilizar tais dados exclusivamente para o desenvolvimento dos serviços de medicina e segurança do trabalho.'
        },
        {
          title: 'Vazamento de Dados ou Acessos Não Autorizados – Penalidades',
          paras: [
            'As partes poderão entrar em acordo, quanto aos eventuais danos causados, caso exista o vazamento de dados pessoais ou acessos não autorizados, e caso não haja acordo, a CONTROLADORA tem ciência que estará sujeita às penalidades previstas no artigo 52 da Lei n° 13.709/2018:'
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>
.lgpd-wrap {
  padding-top: 40px;
  padding-bottom: 64px;
}
.lgpd-col {
  max-width: 80ch;
  display: flex;
  flex-direction: column;
  gap: 26px;
}
.lgpd-title {
  margin: 0 0 8px;
  align-self: center;
  text-align: center;
  max-width: 80ch;
  font-size: 27px;
  line-height: 1.3;
  font-weight: 700;
  text-wrap: pretty;
}
.lgpd-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 44px;
  margin-top: 22px;
  border-top: 1px solid #e8ecf3;
}
.lgpd-h2 {
  margin: 0;
  font-size: 21px;
  line-height: 1.35;
  font-weight: 700;
  color: #2c3a4c;
  text-wrap: pretty;
}
.lgpd-h3 {
  margin: 8px 0 0;
  font-size: 16.5px;
  line-height: 1.45;
  font-weight: 700;
  color: #2c3a4c;
  text-wrap: pretty;
}
.lgpd-p {
  margin: 0;
  font-size: 16px;
  line-height: 1.85;
  color: #3a4859;
  text-wrap: pretty;
}
.lgpd-p--tight {
  font-size: 15.5px;
  line-height: 1.75;
}
.lgpd-num {
  display: grid;
  grid-template-columns: 34px 1fr;
  gap: 0 12px;
  align-items: start;
}
.lgpd-num-n {
  font-size: 15.5px;
  font-weight: 700;
  line-height: 1.75;
  color: #1a6fd4;
}
.lgpd-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 13px;
}
.lgpd-list--nested {
  margin-top: 12px;
}
.lgpd-li {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 13px;
  align-items: start;
  font-size: 15.5px;
  line-height: 1.7;
  color: #3a4859;
  text-wrap: pretty;
}
.lgpd-dot {
  width: 5px;
  height: 5px;
  border-radius: 99px;
  background: #a9b6c8;
  margin-top: 9px;
}
</style>
